// AG-Grid
import { ColDef, ICellRendererParams, ValueFormatterParams, ValueParserParams } from "ag-grid-community";

// EZ
import { DateHelper } from "@template-ui/helpers";


// TODO: This depends on DynamicForm which is still not in EZ Lib
import { ViewMoreCellRenderer } from "./view-more-cell-renderer/view-more-cell-renderer.component";
import { ButtonsCellRenderer, EzButtonCellParams } from "@template-ui/components/ez-grid/cell-renderers/buttons-cell-renderer/buttons-cell-renderer.component";
import { ButtonConfig } from "@template-ui/types";
import { AppUILabels } from "@app/shared/ui-labels.constants";

/*
  This stuff is its own file cuz there's a lot of documentation and keeps the ez-grid and
  any other implementations of an ag-grid clean.

  For AG Grid renderers, formatters etc., DEFINE them in their own class under ag-grid-cells but
  put the DOCUMENTATION in here. This way, when a dev wants to a column type in the ColDefs, then
  can just type:

     EzGridColTypes.Render<whatever> and the intellisense will show the documentation.

  VS Code should offer to import this file when they do that.

  To make things easy to find, prefix all strings with Render, Format, Edit or whatever
*/

/**
 * Just a place to hold some width values that get used a lot
 * TODO: Move these to a more app-specific place if the grid package becomes reusable.
 */
export class AppGridWidths {
  static CdcrNum = 100;
  static CaseId = 100;
  static PlanId = 100;
  static DateOnly = 100;
  static DateAndTime = 200;
  static Location = 300;
}

/** @deprecated Use `AppGridWidths` instead. */
export { AppGridWidths as BitsGridWidths };

/**
 * Enum for easy access to BuiltInColumnTypes. Import this into your component that uses an AG-Grid based grid.
 */
// export class EzGridColTypes  {
//   // These properties map to strings in the AgGridColumnTypes class (below). If you add another type, be sure
//   // to update this list to make it easy to find. Documentation is here to make it easy to read
//   // in the parent component when you are specifying one of these types. Since the documentation is here
//   // it doesn't need to be on the actual renderer, formatter etc.


// /**
//  * ## RenderHyperlink
//  * Render the cell text as a hyperlink. Pass the link through the cellRendererParams property.
//  * For internal links, use **routerLink**, for external links use **href**. You can also specify **target**,
//  * **title** (for tooltip) and **value**. All parameters can contain {{field}} tokens and will be resolved
//  * with data from the row.
//  *
//  * Examples:
//  * ```
//  *  cellRendererParams: {href:'https://google.com'}               // Static external link using href
//  *
//  *  cellRendererParams: {routerLink: 'customers'}                 // Static internal router link
//  *
//  *  cellRendererParams: {routerLink: 'customer/{{custNum}}';  }   // Internal router link using a field from the row data
//  *
//  *  cellRendererParams: {href: '{{url}}';  }                      // External href using a field from the row data
//  * ```
//  * If you want to handle a click without navigating:
//  * In the parent component, add your click handler to the grid options context like this:
//  * ```
//  * onDownloadReportLinkClicked(params: ICellRendererParams)
//  * {
//  *    // Do stuff when the link is clicked, the params param gives you access to the rowData,
//  *    // column info and passed-in cellRenderParams.... go nuts.
//  *    console.log(`download link clicked for report ${params.data.id}`);
//  * }
//  *
//  * // Pass the the click handler to the context of the grid options.
//  * agGridOptions: GridOptions = {
//  *      context: {
//  *        downloadReport: this.onDownloadReportLinkClicked.bind(this)
//  *      }
//  *    }
//  * ```
//  * And in the colDefs, specify the name of the click handler like this:
//  * ```
//  * colDefs:[
//  *  { field: "downloadLink", type: [EzGridColTypes.RenderHyperlink]
//  *   , cellRendererParams: {value: 'Download {{name}}' onClickMethod(): "downloadReport", ...}, ... },
//  *  ....
//  * ]
//  * ```
//  * Make sure the value of the onClickMethod matches the name of the property in the context.
//  *
//  * For a tooltip, pass the title property in the cellRendererParams. It will also be resolved with field tokens
//  * , title: "View documents for {{cdcrNum}}"
//  *
//  *
//  */
//   static RenderHyperlink = 'hyperlinkeRenderer';

//   /**
//    * Custom AG Grid cell renderer for safely injecting and displaying resolved HTML templates.
//    *
//    * Uses `TextTemplateService` to transform input text using row context, supports clickable templates
//    * via named callback method in grid context, and optionally displays a skeleton loader.
//    *
//    * ### Example usage:
//    * ```ts
//    * {
//    *   field: 'description',
//    *   cellRenderer: InnerHtmlRenderer,
//    *   cellRendererParams: {
//    *     value: '<div (click)="handleClick()">Resolved {{ status }}</div>',
//    *     showSkeleton: isLoading
//    *   }
//    * }
//    *
//    * // In grid options context:
//    * context: {
//    *   handleClick: (params) => console.log('Row clicked', params.data)
//    * }
//    * ```
//    */
//   static RenderInnerHtml = 'renderInnerHtml';

//   /**
//    * Render one or more buttons within a cell.
//    * To configure the buttons do this:
//    * ```typescript
//    * cellRendererParams: {
//    *   buttonsConfig: this.gridButtonsConfig,
//    *   onButtonClick: (event: CellButtonClickEvent) => this.doSomething(event)
//    * }
//    * ...
//    *
//    * doSomething(e: CellButtonClickEvent) {
//    *   switch(e.buttonConfig.id) {
//    *     case "delete":
//    *       this.delete(e.rowData);
//    *       break;
//    *
//    *     case "submit":
//    *       this.submit(e.rowData);
//    *       break;
//    *   }
//    * }
//    * ```
//    * where gridButtonsConfig is a ```ButtonConfig[]```
//    *
//    * To handle button clicks, DO NOT specify the onClick function for each button, that won't work.
//    * Instead specify the cellRendererParams.onButtonClick. The event will contain the rowData and the
//    * buttonConfig so you know which button was clicked.
//    *
//    * The following ButtonConfig properties can use templates which will be resolved with
//    * the Text Template Service using the row data:
//    * - buttonText
//    * - routerLink
//    * - href
//    * - shiftLink
//    * - shiftUrl
//    * - fragment
//    * - toolTip
//    */
//   static RenderButtons = 'renderButtons';

//   /**
//    * Date formatter - will ultimately use the Angular formatDate method
//    * See: https://angular.dev/api/common/DatePipe for format options
//    */
//   static FormatDate = 'formatDate';

//   /**
//    * Date and time formatter - will ultimately use the Angular formatDate method
//    * with a default format of 'MM/dd/yyyy hh:mm a'  (capital AM/PM)
//    * See: https://angular.dev/api/common/DatePipe for format options
//    */
//   static FormatDateTime = 'formatDateTime';

//    /**
//    * Time formatter - will ultimately use the Angular formatDate method
//    * with a default format of 'hh:mm a'  (capital AM/PM)
//    * See: https://angular.dev/api/common/DatePipe for format options
//    */
//   static FormatTimeOnlyColumn =  'formatTimeOnlyColumn';

//   // TODO: BITS-specific stuff, move to a different file.

//   /**
//    * Sets the default date formatter and width for a date column
//    */
//   static DateOnlyColumn = 'dateOnlyColumn';

//   // static FlexDateOnlyColumn = 'flexDateOnlyColumn';

//   /**
//    * Date/Time used in a flex column
//    */
//   // static FlexDateTimeColumn = 'flexDateTimeColumn';

//   /**
//    * Sets the default date formatter and width for a date and time column
//    * with a default format of 'MM/dd/yyyy hh:mm a'  (capital AM/PM)
//    * See: https://angular.dev/api/common/DatePipe for format options.
//    * And a fixed width of EzGridWidths.DateAndTime
//    */
//   static DateTimeColumn = 'dateTimeColumn';

//   /**
//    * Since we have lots of grids with a Cdcr column, all the props
//    * are grouped together in this type. Use it to be consistent unless you
//    * need something different.
//    */
//   static CdcrColumn = 'cdcrColumn';

//   /**
//    * To render a single radio button - may be combined with RadioButtonRenderer
//    */
//   static SingleRadioButtonRenderer = 'singleRadioButtonRenderer'

//   /**
//    * Sets several properties necessary to make text wrapping
//    * work.
//    * ```typescript
//    * bitsWrapText: {
//    * autoHeight: true,
//    *   wrapText: true,
//    *   cellStyle: {
//    *     whiteSpace: 'normal',
//    *     wordBreak: 'break-word'
//    *  },
//    * } as ColDef,
//    * ```
//    */
//   static BitsWrapText = 'bitsWrapText';

//   /**
//    * Center aligns the cell content and header
//    * by setting
//    * ```ts
//    * centerAligned : {
//    *   headerClass: 'ag-center-aligned-header',
//    *   cellClass: 'ag-center-aligned-cell'
//    * } as ColDef,
//    *   ```
//    */
//   static CenterAligned = 'centerAligned';

//   /**
//    * Use for a property grid. Sets flex=1 and resizeable=false.
//    */
//   static Prop = 'bitPropertyColumn';

//   /**
//    * This column is meant to be the rightmost column in a property grid.
//    * It will be invisible. Set the flex value to take up the remaining space.
//    * I.e. if you are lining up grids with 8 columns and this grid has only 3
//    * columns, set the flex to 5.
//    */
//   static Ghost = 'bitsGhostColumn';



//   static MappedValueRenderer = 'mappedValueRenderer'

//   /**
//    * Uses the MappedValueRenderer to map true: 'Yes' and false: 'No'
//    */
//   static YesNoRenderer = 'yesNoRenderer'
// }


/**
 * This class maps AG Grid 'type' strings to actualy cell renderers, editors, formatters etc.
 */

export class AppGridColumnTypes {

    static numberValueParser(params:ValueParserParams):number | null {
        // zero is not null
        if(!params.newValue && params.newValue != '0') {
          return null;
        }

        if(parseFloat(params.newValue)) {
          return Number(params.newValue);
        }

        throw "Invalid number";
    }

    static dateCellRenderer(params: ICellRendererParams) {

        let text:string = 'unknown';
        let real:boolean = true;
        if(!params.value)
        {
          if(params.value == null) text = ''; // was 'null';
          if(params.value == undefined) text = '';  // was 'undefined'. Why?
          if(params.value == '') text = 'blank';
          //return `<span style="color:lightgrey;">${text}</span>`;
          real = false;
        }
        else{
          const date = Date.parse(params.value);

          if(isNaN(date)) {
            text = 'NaN'
            real = false;
          }
          else {
            if(new Date(params.value).getMinutes() == 0)
            {
              text = DateHelper.formatDateWithDefaults(params.value.toString().replace('Z',''));
            }
            else
            {
              text = DateHelper.formatDateWithDefaults(params.value);
            }
            real = true;
          }
        }

        if(text.includes('/0001')) {
          text = "invalid";
          real = false;
        }

        if(real) return text;

        const toolTip = "this is a tooltip";

        //return `<span class="grid-dim-text" mat-tool-tip="toolToip">${text}</span>`;
        return `<span data-date-value="${text}">${text}</span>`;
    }

    static dateTimeFormatter(params: ValueFormatterParams):string {
    let text:string = 'unknown';
    let real:boolean = true;
    if(!params.value)
    {

        if(params.value == null) text = 'null';
        if(params.value == undefined) text = '';
        if(params.value == '') text = 'blank';
        //return `<span style="color:lightgrey;">${text}</span>`;
        real = false;
    }
    else
    {
        const date = Date.parse(params.value);

        if(isNaN(date)) {
        text = 'NaN'
        real = false;
        }
        else {
        let format = DateHelper.DefaulDateFormat;
        if(params.colDef.cellRendererParams && params.colDef.cellRendererParams.format)
        {
            format = params.colDef.cellRendererParams.format;
        }
        text = DateHelper.formatDateWithDefaults(params.value, format);
        real = true;
        }
    }

    if(text.startsWith('01/01/0001')) {
        text = "invalid";
        real = false;
    }

    if(real) return text ;

    return text;
    }

    /* These are re-usable column types, shared accross all grids.
     You can override or add to these in the specific component by doing this:
     let ColumnTypes = {...CapsGridComponent.BuiltInColumnTypes, ...{ My column types}}
   */

  /**
   * Since we have lots of grids with a Cdcr column, all the props
   * are grouped together in this type. Use it to be consistent unless you
   * need something different. This sets the following:
   * ```ts
   * cdcrColumn: {
   *   headerName: AppUILabels.CDCR_LABEL,
   *   flex: 0,
   *   width: AppGridWidths.CdcrNum,
   *   resizable:false
   * }
   * ```
   */
  static CdcrColumn = 'cdcrColumn';
  /** @deprecated Use `CdcrColumn` instead. */
  static BitsCdcrColumn = 'bitsCdcrColumn';

  /**
   * Since we have lots of grids with a CDCR # column that is a button, all the props
   * are grouped together in this type. Use it to be consistent unless you
   * need something different. This sets the following:
   * ```ts
   * cdcrButtonColumn: {
   *   headerName: AppUILabels.CDCR_LABEL,
   *   flex: 0,
   *   width: AppGridWidths.CdcrNum,
   *   resizable:false,
   *   cellRenderer: ButtonsCellRenderer,
   *   cellRendererParams: {
   *      buttonsConfig: [{ id: 'cdcNum', buttonText: '{{cdcNum}}', containerClass: 'button-width' } as ButtonConfig],
   *   } satisfies EzButtonCellParams,
   * }
   * ```
   */
  static CdcrButtonColumn = 'cdcrButtonColumn';
  /** @deprecated Use `CdcrButtonColumn` instead. */
  static BitsCdcrButtonColumn = 'bitsCdcrButtonColumn';

    /**
   * Since we have some grids with a Case Id column that is a button, all the props
   * are grouped together in this type. Use it to be consistent unless you
   * need something different. This sets the following:
   * ```ts
   * caseIdButtonColumn: {
   *   headerName: 'Case ID',
   *   flex: 0,
   *   width: AppGridWidths.CaseId,
   *   resizable:false,
   *   cellRenderer: ButtonsCellRenderer,
   *   cellRendererParams: {
   *      buttonsConfig: [{ id: 'caseId', buttonText: '{{caseId}}', containerClass: 'button-width' } as ButtonConfig],
   *   } satisfies EzButtonCellParams,
   * }
   * ```
   */
  static CaseIdButtonColumn = 'caseIdButtonColumn';
  /** @deprecated Use `CaseIdButtonColumn` instead. */
  static BitsCaseIdButtonColumn = 'bitsCaseIdButtonColumn';

    /**
   * Since we have some grids with a Plan Id column that is a button, all the props
   * are grouped together in this type. Use it to be consistent unless you
   * need something different. This sets the following:
   * ```ts
   * planIdButtonColumn: {
   *   headerName: 'Plan ID',
   *   flex: 0,
   *   width: AppGridWidths.PlanId,
   *   resizable:false,
   *   cellRenderer: ButtonsCellRenderer,
   *   cellRendererParams: {
   *      buttonsConfig: [{ id: 'planId', buttonText: '{{planId}}', containerClass: 'button-width' } as ButtonConfig],
   *   } satisfies EzButtonCellParams,
   * }
   * ```
   */
  static PlanIdButtonColumn = 'planIdButtonColumn';
  /** @deprecated Use `PlanIdButtonColumn` instead. */
  static BitsPlanIdButtonColumn = 'bitsPlanIdButtonColumn';

  /**
   * Date formatter - will ultimately use the Angular formatDate method
   * See: https://angular.dev/api/common/DatePipe for format options
   */
  static FormatDate = 'formatDate';

  /**
   * Sets the default date formatter and width for a date column
   */
  static DateOnlyColumn = 'dateOnlyColumn';
  /** @deprecated Use `DateOnlyColumn` instead. */
  static BitsDateOnlyColumn = 'bitsDateOnlyColumn';

  /**
   * Sets the default date formatter without a fixed width.
   */
  static FlexDateOnlyColumn = 'flexDateOnlyColumn';
  /** @deprecated Use `FlexDateOnlyColumn` instead. */
  static BitsFlexDateOnlyColumn = 'bitsFlexDateOnly';

  /**
   * Time formatter - will ultimately use the Angular formatDate method
   * with a default format of 'hh:mm a'  (capital AM/PM)
   * See: https://angular.dev/api/common/DatePipe for format options
   */
  static FormatTimeOnlyColumn =  'formatTimeOnlyColumn';

  /**
   * Sets the default date formatter and width for a date and time column
   * with a default format of 'MM/dd/yyyy hh:mm a'  (capital AM/PM)
   * See: https://angular.dev/api/common/DatePipe for format options.
   * And a fixed width of AppGridWidths.DateAndTime
   */
  static DateTimeColumn = 'dateTimeColumn';
  /** @deprecated Use `DateTimeColumn` instead. */
  static BitsDateTimeColumn = 'bitsDateTimeColumn';

  /**
   * This column will display the first 100 characters of a string, and display
   * a "View" button to open a model and see the rest of the text.
   * TODO: Move this to EZ Lib once it is no longer dependent on the outside world.
   */
  static ViewMore = 'viewMoreRenderer';

  private static readonly formatDateColumnType: ColDef = {
    valueFormatter: AppGridColumnTypes.dateTimeFormatter,
    // filter: 'agDateColumnFilter',
    // filterParams: {buttons: ['clear']}
  };

  private static readonly formatDateTimeColumnType: ColDef = {
    valueFormatter: AppGridColumnTypes.dateTimeFormatter,
    cellRendererParams : {format: 'MM/dd/yyyy hh:mm a'}
  };

  private static readonly formatTimeOnlyColumnType: ColDef = {
    valueFormatter: AppGridColumnTypes.dateTimeFormatter,
    cellRendererParams : {format: 'hh:mm:ss a'}
  };

  private static readonly dateOnlyColumnType: ColDef = {
    valueFormatter: AppGridColumnTypes.dateTimeFormatter,
    maxWidth: AppGridWidths.DateOnly,
    resizable: false
  };

  private static readonly flexDateOnlyColumnType: ColDef = {
    valueFormatter: AppGridColumnTypes.dateTimeFormatter
  };

  private static readonly dateTimeColumnType: ColDef = {
    valueFormatter: AppGridColumnTypes.dateTimeFormatter,
    cellRendererParams : {format: 'MM/dd/yyyy hh:mm a'},
    maxWidth: AppGridWidths.DateAndTime,
    resizable: false
  };

  private static readonly cdcrColumnType: ColDef = {
    headerName: AppUILabels.CDCR_LABEL,
    flex: 0,
    width: AppGridWidths.CdcrNum,
    resizable:false
  };

  private static readonly cdcrButtonColumnType: ColDef = {
    headerName: AppUILabels.CDCR_LABEL,
    flex: 0,
    width: AppGridWidths.CdcrNum,
    maxWidth: AppGridWidths.CdcrNum,
    resizable:false,
    cellRenderer: ButtonsCellRenderer,
    cellRendererParams: {
      buttonsConfig: [{ id: 'cdcNum', buttonText: '{{cdcNum}}', containerClass: 'button-width' } as ButtonConfig],
        } satisfies EzButtonCellParams,
  };

  private static readonly caseIdButtonColumnType: ColDef = {
    headerName: 'Case ID',
    flex: 0,
    width: AppGridWidths.CaseId,
    resizable:false,
    cellRenderer: ButtonsCellRenderer,
    cellRendererParams: {
      buttonsConfig: [{ id: 'caseId', buttonText: '{{caseId}}', containerClass: 'button-width' } as ButtonConfig],
        } satisfies EzButtonCellParams,
  };

  private static readonly planIdButtonColumnType: ColDef = {
    headerName: 'Plan ID',
    flex: 0,
    width: AppGridWidths.PlanId,
    resizable:false,
    cellRenderer: ButtonsCellRenderer,
    cellRendererParams: {
      buttonsConfig: [{ id: 'planId', buttonText: '{{planId}}', containerClass: 'button-width' } as ButtonConfig],
        } satisfies EzButtonCellParams,
  };

  static BuiltInColumnTypes: {[key: string]: ColDef;} =
  {

    formatDate: AppGridColumnTypes.formatDateColumnType,

    formatDateTime: AppGridColumnTypes.formatDateTimeColumnType,

    formatTimeOnlyColumn: AppGridColumnTypes.formatTimeOnlyColumnType,

    [AppGridColumnTypes.DateOnlyColumn]: AppGridColumnTypes.dateOnlyColumnType,
    [AppGridColumnTypes.BitsDateOnlyColumn]: AppGridColumnTypes.dateOnlyColumnType,

    [AppGridColumnTypes.FlexDateOnlyColumn]: AppGridColumnTypes.flexDateOnlyColumnType,
    [AppGridColumnTypes.BitsFlexDateOnlyColumn]: AppGridColumnTypes.flexDateOnlyColumnType,

    // mappedValueRenderer: {
    //   cellRenderer: MappedValueRenderer
    // },

    // yesNoRenderer: {
    //   cellRenderer: MappedValueRenderer,
    //   cellRendererParams: {valueMap: {
    //     true: 'Yes',
    //     false: 'No',
    //     }
    //   }
    // },

    [AppGridColumnTypes.DateTimeColumn]: AppGridColumnTypes.dateTimeColumnType,
    [AppGridColumnTypes.BitsDateTimeColumn]: AppGridColumnTypes.dateTimeColumnType,

    [AppGridColumnTypes.CdcrColumn]: AppGridColumnTypes.cdcrColumnType,
    [AppGridColumnTypes.BitsCdcrColumn]: AppGridColumnTypes.cdcrColumnType,

    [AppGridColumnTypes.CdcrButtonColumn]: AppGridColumnTypes.cdcrButtonColumnType,
    [AppGridColumnTypes.BitsCdcrButtonColumn]: AppGridColumnTypes.cdcrButtonColumnType,

    [AppGridColumnTypes.CaseIdButtonColumn]: AppGridColumnTypes.caseIdButtonColumnType,
    [AppGridColumnTypes.BitsCaseIdButtonColumn]: AppGridColumnTypes.caseIdButtonColumnType,

    [AppGridColumnTypes.PlanIdButtonColumn]: AppGridColumnTypes.planIdButtonColumnType,
    [AppGridColumnTypes.BitsPlanIdButtonColumn]: AppGridColumnTypes.planIdButtonColumnType,

    viewMoreRenderer: {
      cellRenderer: ViewMoreCellRenderer
    },

    // singleRadioButtonRenderer: {
    //   cellRenderer: SingleRadioButtonRendererComponent,
    // },

    // bitPropertyColumn: {
    //   resizable: false,
    //   flex: 1,
    //   suppressMovable: true
    // } as ColDef,

    // bitsGhostColumn: {
    //   resizable: false,
    //   sortable: false,
    //   suppressMovable: true,
    //   suppressHeaderFilterButton: true,
    //   suppressNavigable: true,
    //   lockPosition:"right",  // So that other columns cannot be dragged into the ghost columns
    //   flex: 1,               // You'll probably want to override this with a value to take up the rest of the space
    //   cellRenderer: InvisibleCellRenderer,
    //   headerClass: 'ghost-header',
    //   cellClass: 'ghost-cell'

    // } as ColDef,

    // bitsWrapText: {
    // autoHeight: true,
    //   wrapText: true,
    //   cellStyle: {
    //     whiteSpace: 'normal',
    //     wordBreak: 'break-word'
    //   },
    // } as ColDef,

    // centerAligned : {
    //   headerClass: 'center-header',
    //   //cellClass: 'ag-center-aligned-cell'
    //   cellStyle: {textAlign: 'center'}
    //  } as ColDef,

    //   stringColumn: {
    //     filterParams: {buttons: ['clear']}
    //   },

    //   numberColumn: {
    //     filter: 'agNumberColumnFilter',
    //     filterParams: {buttons: ['clear']},
    //     valueParser: AgGridColumnTypes.numberValueParser
    //   },



    //   dateColumnRender: {
    //     //valueFormatter: CapsGridComponent.dateTimeFormatter,
    //     cellRenderer: AgGridColumnTypes.dateCellRenderer,
    //     //cellEditor: AgGridDatePickerRendererComponent,
    //     filter: 'agDateColumnFilter',
    //     filterParams: {
    //       buttons: ['clear'],
    //       inRangeInclusive: true,
    //       //buttons: ['apply','clear'],
    //       comparator:(filterDate: Date, cellDateStr: string):number => {
    //         /*
    //           The fitlerDate is a 'real' DateTime with local TZ info but no time component (i.e. midnight).
    //           i.e.: "Wed Aug 03 2022 00:00:00 GMT-0700". In order for 'Equals' to work, the
    //           cell date must not contain time information.

    //           https://www.ag-grid.com/angular-data-grid/filter-date/
    //           Returns:
    //           + Any number < 0 if the cell value is less than the filter date.
    //           + 0 if the dates are the same.
    //           + Any number > 0 if the cell value is greater than the filter date.
    //         */

    //         // Get the filter date as a date-only string (no TZ info)
    //         let filterDateString = filterDate.toISOString().substring(0,10); // 1969-07-20

    //         // Is the Cell Date a real date or a Date-only string?
    //         if(cellDateStr.length > 10)
    //         {
    //           // Real DateTime - including time component

    //           // This will be the date as stored (no conversion) - Will throw error if it cannot be made into a Date?
    //           // NOTE: This assumes that the only TZ information we ever store is UTC.
    //           let cellAsDateWithNoTzInfo = new Date(cellDateStr.replace('Z',''));

    //           // Check for 0 time WITHOUT conversion, because the conversion might have added a time component
    //           // If there are no ms, seconds, minutes or hours (without converting to local time), then assume this is a 'pure' date in local time

    //           if(cellAsDateWithNoTzInfo.getMilliseconds() == 0
    //             && cellAsDateWithNoTzInfo.getSeconds() == 0
    //             && cellAsDateWithNoTzInfo.getMinutes() == 0
    //             && cellAsDateWithNoTzInfo.getHours() == 0)
    //           {
    //               /* This is only necessary if the API is returning a date-only as a DateTime like this: 1969-07-20T00:00:00Z
    //               , which it shouldn't do */

    //               let cellAsDateWithNoTzInfoStr = DateHelper.formatDateWithDefaults(cellAsDateWithNoTzInfo, DateHelper.IsoDateOnlyFormat);  // <-- No time zone

    //               // cellAsDateWithNoTzInfoStr - Has no time information or TZ string
    //               // filterDate - Has not time information or TZ string
    //               return cellAsDateWithNoTzInfoStr.localeCompare(filterDateString);
    //           }
    //           else
    //           {
    //             /* This is the normal case for a DateTime - But in our filter, we only care about the date (for equals) */

    //             // CellDate is a real date-time with a time component. Convert to local time, then just compare the date part

    //             // Convert to a JavaScript Date - this will automatically be converted from UTC to local time
    //             let cellAsLocalDate:Date = new Date(cellDateStr);

    //             // 'Make' a new date that is local but with a 0 time component and no time zone. JavaScript will interpret as midnight local time
    //             let formattedDateOnly = DateHelper.formatDateWithDefaults(cellAsLocalDate,DateHelper.IsoDateOnlyFormat) + "T00:00";  // <-- No time zone

    //             // Now we have a 'real' Date that has only date information and no timezone information (i.e. local)
    //             cellAsLocalDate = new Date(formattedDateOnly);

    //             // cellAsLocalDate - Has no time information uses local TZ
    //             // filterDate - Has no time information uses local TZ
    //             //return compareAsc(filterDate, cellAsLocalDate);
    //             let rtn = compareAsc(cellAsLocalDate, filterDate);
    //             // if(rtn == 0)
    //             //   console.log("equal")
    //             // else
    //             //   console.log(rtn);

    //             return rtn;
    //           }
    //         }
    //         else
    //         {
    //           /* This is the normal case when the database stores and returns a date-only */

    //           // Date-only string in the format 1969-07-20T00:00:00Z
    //           // the filterDate is a real date with local TZ info, convert to ISO and strip off the time component
    //           //let filterDateString = filterDate.toISOString().substring(0,10);  // 1969-07-20

    //           // The cell date is a date-only with no time-zone information and so is filterDateString.
    //           // These are easly compared as strings
    //           return cellDateStr.localeCompare(filterDateString);  // compare strings
    //         }

    //         return 0;
    //       }
    //     }
    //   }

    //   //, comparator: CapsGridComponent.dateComparator }
    //    // TODO: Make a good editor for dates, preferably the Mat UI datepicker
    //  , dateColumnEditable:{

    //     //cellRenderer: AgGridDatePickerRendererComponent,
    //     filter: 'agDateColumnFilter',
    //     filterParams: {
    //       buttons: ['clear'],
    //       comparator: (filterLocalDateAtMidnight: Date, cellValue: any ): number => {
    //         // Cell value is an ISO date
    //         return compareAsc( DateHelper.dateInCurrentTimeZoneFromIsoDateOnly(cellValue), filterLocalDateAtMidnight);
    //         //console.log(cellValue);
    //         //return 0;
    //       },
    //       inRangeInclusive: true

    //     }
    //   } //, comparator: CapsGridComponent.dateComparator }
    //   ,

    //   booleanCheckboxColumn :{
    //     cellRenderer: CheckboxCellRenderer,
    //   },


    //  csvChips: {
    //   cellRenderer: AgGridCsvChipsRendererComponent
    // },

    //  bold: {
    //   cellRenderer: AgGridBoldCellRendererComponent,
    // },

    // // Render the text in the cell as a button?
    // button: {
    //     cellRenderer: ButtonCellRenderer
    // }

  };

  /** @deprecated Use `BuiltInColumnTypes` instead. */
  static BitsGridBuiltInColumnTypes = AppGridColumnTypes.BuiltInColumnTypes;

  /**
     * These are re-usable column types, shared accross all grids.
     * You can override or add to these in the specific component by doing this:
     * let ColumnTypes = {...AgGridComponent.BuiltInColumnTypes, ...{ My column types}}
     * From Tom's stuff... merging.
     */
    // public static BuiltInColumnTypes1: { [key: string]: ColTypeDef } = {


    //   dateColumn: {
    //     filter: 'agDateColumnFilter',
    //     filterParams: { buttons: ['clear'] },
    //     valueFormatter: AgGridComponent.dateFormatter,
    //   },

    //   dateColumnNoFilter: {
    //     valueFormatter: AgGridComponent.dateFormatter,
    //   },

    //   dateTimeColumnNoFilter: {
    //     valueFormatter: AgGridComponent.dateTimeFormatter,
    //   },
    // };

    // /**
    //  * Enum for easy access to BuiltInColumnTypes
    //  */
    // public static ColumnTypes = {
    //   DateColumn: 'dateColumn',
    //   DateColumnNoFilter: 'dateColumnNoFilter',
    //   DateTimeColumnNoFilter: 'dateTimeColumnNoFilter',
    // };

    // /**
    //  * Default grid options - put stuff here that should apply to most grids. Developer can still
    //  * override these in the specific grid component.
    //  */
    // public static DefaultGridOptions: GridOptions = {
    //   columnTypes: AgGridComponent.BuiltInColumnTypes,
    // };

}

/** @deprecated Use `AppGridColumnTypes` instead. */
export { AppGridColumnTypes as BitsGridColumnTypes };

// export class EzGridColClass {
//   static alert: string = 'ag-alert-row';
//   static warn: string = 'ag-warn-row';
// }
